import { ValidationErrors } from '@angular/forms';

/**
 * A class used to hold the current validation context for a form.
 */
export class FormValidationContext {
  errors: ValidationErrors;
  values: Dictionary<string>;
}
